<template>
  <v-menu
    :value="currentValue"
    offset="4"
    @update:model-value="updateMenuModelValue"
  >
    <template #activator="{ isActive, props }">
      <slot
        v-if="visibleActivator"
        v-bind="{ isActive, props }"
      />
    </template>
    <v-list
      rounded
      border="0"
      elevation="10"
      density="compact"
      class="pa-2"
      max-height="214px"
    >
      <v-list-item
        v-for="(item, key) in items"
        :key="key"
        rounded
        class="pa-2"
        @click="emit('select', item)"
      >
        <template
          v-if="item.icon"
          #prepend
        >
          <v-icon
            :icon="item.icon"
            size="16"
            class="text-beton64"
          />
        </template>

        <v-list-item-title
          class="text-h4 text-beton64"
          v-text="item.label"
        />
      </v-list-item>

      <!--  slot for append actions in lists-->
      <slot name="append-list-item" />
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
defineOptions({
  name: 'XDropDown',
});

export type TItem = { label: string; icon?: string; value?: string; callback?: () => void };

const {
  useModel = false,
  items = [],
  visibleActivator = true,
} = defineProps<{
  items?: Array<TItem>;
  useModel?: boolean;
  visibleActivator?: boolean;
}>();

const emit = defineEmits<{
  (_eventName: 'select', _item: TItem): void;
  (_eventName: 'update:modelValue', _e: boolean): void;
}>();

const value = defineModel<boolean>({ default: false });

const currentValue = computed(() => (useModel ? value : undefined));

function updateMenuModelValue(value: boolean) {
  if (useModel) emit('update:modelValue', value);
}
</script>
